import React, {useEffect, useRef, useState} from 'react';
import {useCurrentLocale, useLocalizedLabels} from "widget-shared-components-library";
import ListingLabels from "./Listing.Labels";
import mapping from "../../config/mapping";
import TagManager from 'react-gtm-module'
import useParams from "../../hooks/useParams";
import useAxiosInstance from "../../hooks/useAxiosInstance";


// const tagManagerArgs = {
//     gtmId: 'GTM-MN5D67'
// }
// TagManager.initialize(tagManagerArgs)

const useListing = () => {
    const initialedObject = {
        items: [],
        count: 0
    };

    const axiosInstance = useAxiosInstance();
    //searchhub params
    const [devices, setDevices] = useState(initialedObject);
    const [rateplans, setRateplans] = useState(initialedObject);
    const [articles, setArticles] = useState(initialedObject);
    const [support, setSupport] = useState(initialedObject);
    const [filterItems, setFilterItems] = useState([]);
    const [filtersForRequest, setFiltersForRequest] = useState([]);
    const [expandedSubCategories, setExpandedSubCategories] = useState({});
    const lang = useCurrentLocale();
    const labels = useLocalizedLabels(ListingLabels);
    const {categoryIdList,categoryNameList} = useParams();
    const [searchQuery, setSearchQuery] = useState('');
    const [selectedTabOption, setSelectedTabOption] = useState('products');

    //promotional products
    const [promotionalIdsList, setPromotionalIdsList] = useState([]);
    const [promoProductsReady, setPromoProductsReady] = useState(false);
    const [promotionDevices, setPromotionDevices] = useState([]);

    //price
    // const [minPriceRange, setMinPriceRange] = useState(0);
    // const [maxPriceRange, setMaxPriceRange] = useState(50);
    const [minPriceRange, setMinPriceRange] = useState(-1);
    const [maxPriceRange, setMaxPriceRange] = useState(-1);
    const [minPrice, setMinPrice] = useState(-1);
    const [maxPrice, setMaxPrice] = useState(-1);
    // const minPriceRange = useRef(null);
    // const maxPriceRange = useRef(null);
    // const prevPriceRangeRef = useRef([null, null]);
    const [isUserInteractedPrice, setIsUserInteractedPrice] = useState(false);

    // Pagination state and constants
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState([4]);
    const [displayPages, setDisplayPages] = useState([]);

    // Product sorting dropdown
    const [productSorting, setProductSorting] = useState([]);

    // Product per page dropdown
    const productsPerPage = mapping.getProductsPerPage(labels);

    useEffect(() => {
        callSearchHubForSortingOptions()

    }, [])

    const callSearchHubForSortingOptions = () => {
        axiosInstance.get(process.env.REACT_APP_API_SORTING_OPTIONS)
            .then((response) => {
                setProductSorting(response?.data?.sortingOptionsMap);
            })
            .catch((error) => {
                console.error(error);
                setProductSorting([]);
            });
    }

    // pagination
    const [selectedProductsPerPage, setSelectedProductsPerPage] = useState({label: labels['perPage12'], value: 12});
    const [selectedProductsSorting, setSelectedProductsSorting] = useState('Sunafeia');

    const [screenWidth, setScreenWidth] = useState(window.innerWidth);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 1200);

    const handleSelectionClick = (option) => () => {
        setCurrentPage(1);
        updateURL("selectedTabOption", option);
        setSelectedTabOption(option);
    };

    const updateURL = (name, value) => {
        const currentURL = new URL(window.location.href);
        currentURL.searchParams.set(name, value);
        window.history.pushState({}, '', currentURL);
        window.location.href = currentURL.toString();
    }

    // Pagination handlers
    const handlePageChange = (pageNum) => {
        setCurrentPage(pageNum);
        updateURL("page", pageNum);
    };
    const handlePrevious = () => {
        if (currentPage > 1) {
            setCurrentPage((prev) => prev - 1);
            updateURL("page", currentPage - 1);
        }
    };
    const handleNext = () => {
        if (currentPage < totalPages[totalPages.length - 1]) {
            setCurrentPage((prev) => prev + 1);
            updateURL("page", currentPage + 1);
        }

    };

    const onPageChange = (page) => {
        setDisplayPages(prevArray => prevArray.map(num => num + 1))
        setCurrentPage(page);
    }
    const handleLearnMore = (productUrl) => {
        window.location.href = window.location.origin+productUrl;
    };

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 1200);
            setScreenWidth(window.innerWidth)
        };
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const handleResponse = (data) => {
        setMinPriceRange(data?.minPrice);
        setMaxPriceRange(data?.maxPrice);
        setDevices(data?.devices);
        setRateplans(data?.rateplans);
        setArticles(data?.articles);
        setSupport(data?.support);
        setFilterItems(data?.filters);
        setSelectedTabOption(data?.devices?.count > 0 ? 'products' : 'rateplans');
        const expandedCategories = data.filters.reduce((acc, item) => {
            if (item?.title === 'Κατηγορία' && item?.items && item?.items.length > 0) {
                const processSubItems = (subItems) => {
                    subItems.forEach(subItem => {
                        acc[subItem?.title] = true;
                        if (subItem?.items && subItem.items.length > 0) {
                            processSubItems(subItem?.items);
                        }
                    });
                };
                processSubItems(item?.items);
            }
            return acc;
        }, {});
        setExpandedSubCategories(expandedCategories);
        setTotalPages(Array.from({length: data?.pages}, (_, i) => i + 1));
    }

    // const localHost = 'http://localhost:8088';
    // const origin = process.env.REACT_APP_POSTPAID_ORIGIN_URL;
    // const isLocalEnv = process.env.NODE_ENV === 'development';
    // const baseUrl = isLocalEnv ? localHost : origin;

    const [parametersReady, setParametersReady] = useState(false);

    const prepareRequest = (size, order, page, collection, q, promotionalIdsList=[], filters) => {
        setParametersReady(false);
        if (filters) {
            const updatedFilters = [
                ...filters.map(([property, value]) => ({
                    property: property,
                    value: value
                })),
                { property: "categoryPath", value: categoryNameList[categoryNameList.length - 1] }
            ];
            setFiltersForRequest(updatedFilters);
        } else {
            setFiltersForRequest([{ property: "categoryPath", value: categoryNameList[categoryNameList.length - 1] }]);
        }

        if (q || promotionalIdsList?.length > 0) {
            if (promotionalIdsList !=null) {
                setSearchQuery(promotionalIdsList);
            }else {
                setSearchQuery(q);
            }
        }

        if (collection) {
            setSelectedTabOption(collection);
        }

        if (size) {
            prepareParameters(size, productsPerPage, setSelectedProductsPerPage);

        }
        if (order) {
            prepareSortingParameters(order, productSorting, setSelectedProductsSorting);
        }

        if (page) {
            setCurrentPage(Number(page));
        }
        if (promotionalIdsList?.length > 0) {
            search(filters, true);
        }
        setPromoProductsReady(true);
        setParametersReady(true);

    }

    const prepareParameters = (param, options, setVariable) => {
        const convertToNum = Number(param);
        const object = options.find((item) => item.value === convertToNum);

        if (object) {
            setVariable(object);
        } else {
            setVariable(null);
        }
    }

    const prepareSortingParameters = (sortingChoice, productSortingMap) => {
        setSelectedProductsSorting(sortingChoice)
    }



    const search = (filters, isForPromotionalProducts = false) => {
        axiosInstance.post(process.env.REACT_APP_API_SEARCH_LISTING,
            {
                q: searchQuery,
                collectionSet: selectedTabOption,
                filters: filters,
                size: selectedProductsPerPage?.value,
                order: selectedProductsSorting?.label,
                page: currentPage,
                language: lang
            })
            .then((response) => {
                if (isForPromotionalProducts === true) {
                    setPromotionDevices(response?.data?.devices)
                    setPromoProductsReady(true);
                }else {
                    handleResponse(response?.data);
                }

            })
            .catch((error) => {
                console.error(error);
            });
    };

    useEffect(() => {
        if (promotionalIdsList?.length > 0) {
            callSearchHub(promotionalIdsList);
        } else {
            callSearchHub([]);
        }

    }, [promotionalIdsList])

    const callSearchHubForPromotionalProducts = () => {
        axiosInstance.get(process.env.REACT_APP_API_SEARCH_PROMO)
            .then((response) => {
                setPromotionalIdsList(response?.data?.promotionalProductsIdList);
            })
            .catch((error) => {
                console.error(error);
                setPromotionalIdsList([]);
            });
    }

    const callSearchHub = (promotionalIdsList) => {
        const currentURL = new URLSearchParams(window.location.search);
        const allParams = {};
        for (const [key, value] of currentURL.entries()) {
            allParams[key] = value;
        }
        const unknownVariables = Object.entries(allParams).filter(([key]) =>
            !['size', 'sort', 'page', 'selectedTabOption', 'q', 'id', 'value','gte','lte'].includes(key)
        );
        setMinPrice(currentURL.get('gte') ?? -1);
        setMaxPrice(currentURL.get('lte') ?? -1);

        prepareRequest(
            currentURL.get('size'),
            currentURL.get('sort'),
            currentURL.get('page'),
            currentURL.get('selectedTabOption'),
            currentURL.get('q'),
            promotionalIdsList,
            unknownVariables
        )
    }

    const onPriceChange = ([newMin, newMax]) => {
        setMinPrice(newMin);
        setMaxPrice(newMax);
    };

    function AfterPriceChange(newMin, newMax) {
        const currentURL = new URLSearchParams(window.location.search);
        const currentMin = currentURL.get("gte");
        const currentMax = currentURL.get("lte");

        if (String(currentMin) === String(newMin) && String(currentMax) === String(newMax)) {
            return;
        }

        if (newMin !== undefined) {
            currentURL.set("gte", newMin);
        }

        if (newMax !== undefined) {
            currentURL.set("lte", newMax);
        }
        // Redirect to the new URL
        window.location.href = `${window.location.pathname}?${currentURL.toString()}`;
    }



    return {
        handlePageChange,
        handlePrevious,
        handleNext,
        selectedTabOption,
        totalPages,
        handleSelectionClick,
        onPageChange,
        currentPage,
        displayPages,
        isMobile,
        screenWidth,
        searchQuery,
        devices,
        articles,
        support,
        rateplans,
        filterItems,
        setDisplayPages,
        search,
        updateURL,
        selectedProductsPerPage,
        selectedProductsSorting,
        setSelectedProductsPerPage,
        setSelectedProductsSorting,
        setCurrentPage,
        handleLearnMore,
        labels,
        parametersReady,
        filtersForRequest,
        expandedSubCategories,
        setExpandedSubCategories,
        promotionDevices,
        promoProductsReady,
        callSearchHubForPromotionalProducts,
        onPriceChange,
        minPriceRange,
        maxPriceRange,
        AfterPriceChange,
        minPrice,
        maxPrice,
        categoryNameList,
        lang,
        productSorting
    };
}
export default useListing;
